import React from 'react';
import VehicleEntityGridPage from './VehicleEntityGridPage';
import { VEHICLE_DOCUMENTS } from './vehicleEntityConfigs';

const VehicleDocuments = () => <VehicleEntityGridPage config={VEHICLE_DOCUMENTS} />;

export default VehicleDocuments;
